import {colors} from '../../../colors/colors';
import {FlashBanner} from '../../../flash-banner/flash-banner';

import {SendProgress} from '../../send-progress/send-progress';

import {ImagePreviewGrid} from './image-preview-grid';
import type {PastedImage, UploadedImage} from './types';

interface Props {
    sendErrorMessage?: string | null;
    shouldShowProgress: boolean;
    isSending: boolean;
    isComplete: boolean;
    hasImages: boolean;
    pastedImages: PastedImage[];
    uploadedImages: UploadedImage[];
    onRemovePasted: (id: string) => void;
    onRemoveUploaded: (id: string) => void;
}

export function MessageInputStatusHeader(props: Props) {
    return (
        <>
            {props.sendErrorMessage && (
                <FlashBanner type='error' duration={3000}>
                    {props.sendErrorMessage}
                </FlashBanner>
            )}
            {props.shouldShowProgress && (
                <SendProgress
                    color={colors.reportOrange}
                    isSending={props.isSending}
                    isComplete={props.isComplete}
                    timeoutInMs={3000}
                />
            )}
            {props.hasImages && (
                <ImagePreviewGrid
                    pastedImages={props.pastedImages}
                    uploadedImages={props.uploadedImages}
                    onRemovePasted={props.onRemovePasted}
                    onRemoveUploaded={props.onRemoveUploaded}
                />
            )}
        </>
    );
}
